// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenGallery_wrapper__3OA_s"};